/* tslint:disable */
/* eslint-disable */
/**
 * STRY API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExerciseDetailsAnswer
 */
export interface ExerciseDetailsAnswer {
    /**
     * 
     * @type {string}
     * @memberof ExerciseDetailsAnswer
     */
    exerciseName?: string;
    /**
     * 
     * @type {string}
     * @memberof ExerciseDetailsAnswer
     */
    graphicUrl?: string;
}

export function ExerciseDetailsAnswerFromJSON(json: any): ExerciseDetailsAnswer {
    return ExerciseDetailsAnswerFromJSONTyped(json, false);
}

export function ExerciseDetailsAnswerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExerciseDetailsAnswer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'exerciseName': !exists(json, 'exercise-name') ? undefined : json['exercise-name'],
        'graphicUrl': !exists(json, 'graphic-url') ? undefined : json['graphic-url'],
    };
}

export function ExerciseDetailsAnswerToJSON(value?: ExerciseDetailsAnswer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'exercise-name': value.exerciseName,
        'graphic-url': value.graphicUrl,
    };
}


